import { IMonitoringAgreementCgsModel, IMonitoringCgsFields } from "../../../../types";

export const monitoring_agreemet_cgs_initial_data: Partial<IMonitoringCgsFields> & Partial<IMonitoringAgreementCgsModel> = {
  used_amount: 0,
  targeted_used_amount: 0,
  nontargeted_used_amount: 0,
  unfulfilled_used_amount_reason: "",
  unfulfilled_used_amount_month_day: 0,
  unfulfilled_used_amount_recommendation_reason: "",
  is_fullfilled_used_amount: false,
  is_deadline_approve: false,
  monitoring_new_deadline: null,
  is_new_deadline_approved: false,
  //fixed_assets_capital_expenditures
  fixed_assets_capital_expenditures: 0,
  targeted_fixed_assets_capital_expenditures: 0,
  nontargeted_fixed_assets_capital_expenditures: 0,
  //machine_equipment_equipment
  machine_equipment_equipment: 0,
  targeted_machine_equipment_equipment: 0,
  nontargeted_machine_equipment_equipment: 0,
  //vehicles_special_technic
  vehicles_special_technic: 0,
  targeted_vehicles_special_technic: 0,
  nontargeted_vehicles_special_technic: 0,
  //purchase_building_land
  purchase_building_land: 0,
  targeted_purchase_building_land: 0,
  nontargeted_purchase_building_land: 0,
  //building_repairs
  building_repairs: 0,
  targeted_building_repairs: 0,
  nontargeted_building_repairs: 0,
  //funds_turnover
  funds_turnover: 0,
  targeted_funds_turnover: 0,
  nontargeted_funds_turnover: 0,
  /////////////////////////////////
  is_female_entrepreneur_checked: false,
  female_entrepreneur_comment: "",
  is_mountain_region_checked: false,
  mountain_region_comment: "",
  is_income_to_k_checked: false,
  income_to_k_comment: "",
  is_sun_gate_beneficiary_checked: false,
  sun_gate_beneficiary_comment: "",
  is_purpose_detailed_provided: false,
  purpose_detailed_comment: "",
  is_project_activities_checked: false,
  project_activities_comment: "",
  representative_id_number: "",
  representative_position: "",
  mountainous_settlement: "",
  attached_documents: {
    monitoring_attachments: [],
  },
  monitoring_approval_status: "",
  monitoring_approval_deadline_comment: "",
  monitoring_deadline_comment: "",
  is_loan_documentation_provided: false,
};

export const monitoring_application_cgs_initial_data: Partial<IMonitoringCgsFields> & Partial<IMonitoringAgreementCgsModel> = {
  used_amount: 0,
  targeted_used_amount: 0,
  nontargeted_used_amount: 0,
  unfulfilled_used_amount_reason: "",
  unfulfilled_used_amount_month_day: 0,
  unfulfilled_used_amount_recommendation_reason: "",
  is_fullfilled_used_amount: false,
  is_deadline_approve: false,
  monitoring_new_deadline: null,
  is_new_deadline_approved: false,
  //fixed_assets_capital_expenditures
  fixed_assets_capital_expenditures: 0,
  targeted_fixed_assets_capital_expenditures: 0,
  nontargeted_fixed_assets_capital_expenditures: 0,
  //machine_equipment_equipment
  machine_equipment_equipment: 0,
  targeted_machine_equipment_equipment: 0,
  nontargeted_machine_equipment_equipment: 0,
  //vehicles_special_technic
  vehicles_special_technic: 0,
  targeted_vehicles_special_technic: 0,
  nontargeted_vehicles_special_technic: 0,
  //purchase_building_land
  purchase_building_land: 0,
  targeted_purchase_building_land: 0,
  nontargeted_purchase_building_land: 0,
  //building_repairs
  building_repairs: 0,
  targeted_building_repairs: 0,
  nontargeted_building_repairs: 0,
  //funds_turnover
  funds_turnover: 0,
  targeted_funds_turnover: 0,
  nontargeted_funds_turnover: 0,
  female_entrepreneur_comment: "",
  mountain_region_comment: "",
  income_to_k_comment: "",
  sun_gate_beneficiary_comment: "",
  purpose_detailed_comment: "",
  project_activities_comment: "",
  is_purchased_activities_checked: false,
  // purchased_activities_comment: "",
  mountainous_settlement: "",
  attached_documents: {
    monitoring_attachments: [],
  },
  monitoring_approval_status: "",
  monitoring_approval_deadline_comment: "",
  monitoring_deadline_comment: "",
  is_loan_documentation_provided: false,
  is_taken_business_loan_leasing: undefined,
};
